const magazineSetDraggableFalseAllImage = () => {
	const images = [...document.querySelectorAll('img')];

	images.forEach(image => image.setAttribute('draggable', false));
}
export { magazineSetDraggableFalseAllImage };